export enum MenuManagementItemActionTypes {
    UPDATE_OUTLET_PRICE = '@@menuManagement/UPDATE_OUTLET_PRICE',
    UPDATE_OUTLET_PRICE_SUCCESS = '@@menuManagement/UPDATE_OUTLET_PRICE_SUCCESS',
    UPDATE_OUTLET_PRICE_ERROR = '@@menuManagement/UPDATE_OUTLET_PRICE_ERROR',

    REGISTER_ITEM = '@@menuManagement/REGISTER_ITEM',
    REGISTER_ITEM_SUCCESS = '@@menuManagement/REGISTER_ITEM_SUCCESS',
    REGISTER_ITEM_ERROR = '@@menuManagement/REGISTER_ITEM_ERROR',

    REGISTER_ITEM_BULK = '@@menuManagement/REGISTER_ITEM_BULK',
    REGISTER_ITEM_BULK_SUCCESS = '@@menuManagement/REGISTER_ITEM_BULK_SUCCESS',
    REGISTER_ITEM_BULK_ERROR = '@@menuManagement/REGISTER_ITEM_BULK_ERROR',

    UPDATE_ITEM_BULK = '@@menuManagement/UPDATE_ITEM_BULK',
    UPDATE_ITEM_BULK_SUCCESS = '@@menuManagement/UPDATE_ITEM_BULK_SUCCESS',
    UPDATE_ITEM_BULK_ERROR = '@@menuManagement/UPDATE_ITEM_BULK_ERROR',

    CLEAR_MENU_ITEM_MESSAGE = 'CLEAR_MENU_ITEM_MESSAGE',

    UPDATE_ITEM = '@@menuManagement/UPDATE_ITEM',
    UPDATE_ITEM_SUCCESS = '@@menuManagement/UPDATE_ITEM_SUCCESS',
    UPDATE_ITEM_ERROR = '@@menuManagement/UPDATE_ITEM_ERROR',

    DELETE_ITEM = '@@menuManagement/DELETE_ITEM',
    DELETE_ITEM_SUCCESS = '@@menuManagement/DELETE_ITEM_SUCCESS',
    DELETE_ITEM_ERROR = '@@menuManagement/DELETE_ITEM_ERROR',

    ITEM_UPDATE_ISACTIVE = '@@menuManagement/ITEM_UPDATE_ISACTIVE',
    ITEM_UPDATE_ISACTIVE_SUCCESS = '@@menuManagement/ITEM_UPDATE_ISACTIVE_SUCCESS',
    ITEM_UPDATE_ISACTIVE_ERROR = '@@menuManagement/ITEM_UPDATE_ISACTIVE_ERROR',

    ITEM_UPDATE_DISABLE = '@@menuManagement/ITEM_UPDATE_DISABLE',
    ITEM_UPDATE_DISABLE_SUCCESS = '@@menuManagement/ITEM_UPDATE_DISABLE_SUCCESS',
    ITEM_UPDATE_DISABLE_ERROR = '@@menuManagement/ITEM_UPDATE_DISABLE_ERROR',
}
